import { render, staticRenderFns } from "./rightTable.vue?vue&type=template&id=58197b56&scoped=true"
import script from "./rightTable.vue?vue&type=script&lang=js"
export * from "./rightTable.vue?vue&type=script&lang=js"
import style0 from "./rightTable.vue?vue&type=style&index=0&id=58197b56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58197b56",
  null
  
)

export default component.exports